import React from 'react';
import BackVideo from '../../components/BackVideo';

import SideLines from '../../components/Svg/side-lines';
import TopLines from '../../components/Svg/top-lines';

export default ({children, video, title, bg, lightBg, showDecor=true, ...props}) => {
    return (
        <div className = {`hud hud-video-player ${lightBg && 'hud_light-bg'}`}>
            <div className = {`hud__container-decor ${lightBg && 'hud__container-decor_light-bg'}`}>
                <div className = 'hud__bg'>
                    <div
                        className = {`hud__bg__video ${lightBg && 'hud__bg__video_light'}`}
                        style = {
                            bg ? {
                                background: 'url(' + bg + ')',
                            } : null
                        }
                    >
                        {video && (
                            <BackVideo video = { video } />
                        )}
                    </div>
                    {showDecor &&
                        <div className = 'hud__bg__decor-top'/>
                    }
                    {showDecor &&
                        <div className = 'hud__bg__decor-bottom'/>
                    }
                </div>

                <div
                    className = 'hud__header'
                    style = {{height: '70px'}}
                >
                    {showDecor &&
                        <div className = 'hud__header__decor__container'>
                            <div className = 'hud__header__decor__row-1 hud__header__decor__row-center'>
                                <div className = 'hud__header__decor__item'>
                                    <TopLines />
                                </div>
                            </div>
                            <div className = 'hud__header__decor__row-2 hud__header__decor__row-space-between'>
                                <div className = 'hud__header__decor__item'>
                                    <SideLines />
                                </div>
                                <div className = 'hud__header__decor__item hud__header__decor__item-reverse'>
                                    <SideLines />
                                </div>
                            </div>
                        </div>
                    }

                    {title && (
                        <div className = {`hud__header__title ${lightBg && 'hud__header__title_light-bg'}`}>{title}</div>
                    )}
                </div>

                <div
                    className = 'hud__footer'
                    style = {{height: '50px'}}
                >
                    {showDecor &&
                        <div className = 'hud__footer__decor__container'>
                            <div className = 'hud__footer__decor__row-1 hud__footer__decor__row-center'>
                                <div className = 'hud__footer__decor__item'>
                                    <TopLines />
                                </div>
                            </div>

                            <div className = 'hud__footer__decor__row-2 hud__footer__decor__row-space-between'>
                                <div className = 'hud__footer__decor__item'>
                                    <SideLines />
                                </div>

                                <div className = 'hud__footer__decor__item hud__footer__decor__item-reverse'>
                                    <SideLines />
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </div>

            {children}
        </div>
    );
};
